import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ThirdPartyTable from "./ThirdPartyTable";
import ThirdPartyB2b from "./ThirdPartyB2b";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import InsuranceClaimInvoice from "../Pages/insuranceClaimInvoice/InsuranceClaimInvoice";
import ClaimInsurancePage from "./ClaimInsurancePage";
import CustomTabs from "../components/Shared/CustomTabs";

export const getDateRange = (range = "lastDay") => {
  const today = new Date();
  let startDate, endDate;

  switch (range) {
    case "lastDay":
      startDate = new Date();
      endDate = new Date();
      endDate.setDate(today.getDate() - 1);
      break;
    case "lastWeek":
      startDate = new Date();
      endDate = new Date();
      startDate.setDate(today.getDate() - 7);
      break;
    case "lastMonth":
      startDate = new Date();
      endDate = new Date();
      startDate.setMonth(today.getMonth() - 1);
      break;
    case "thisMonth":
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;
    default:
      startDate = new Date();
      endDate = new Date();
      break;
  }

  const dateRange = {
    from: startDate.toISOString().split("T")[0],
    to: endDate.toISOString().split("T")[0],
  };

  return dateRange;
};

// const managerTabs = ({ t, user }) => [
//   ...(user?.business_id === 45
//     ? [
//       { label: t("Gallery"), value: "b2c" },
//       { label: t("Store"), value: "b2b" },
//     ]
//     : []),
//   { label: t("Insurance Claims"), value: "ins" },
//   { label: t("His Reception"), value: "hrcp" },
//   { label: t("Pharmacy"), value: "phy" },
// ];

// const galleryTabs = (t) => [{ label: t("Gallery"), value: "b2c" }];
// const storedTabs = (t) => [{ label: t("Store"), value: "b2b" }];

function ThirdParty() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  useEffect(() => {
    if (location?.state?.activeTab) {
      navigate(location.pathname, {
        replace: true,
        state: { ...location.state, activeTab: null },
      });
    }
  }, [location, navigate]);

  const getTabsForUser = () => {
    if (!user) return [];

    if (user.role_id === 1 || user.role_id === 3) {
      return [
        ...(user?.business_id === 40
          ? [
            {
              name: t("Gallery"),
              content: (
                <ThirdPartyTable
                  activeTab="b2c"
                  childIndex={location?.state?.childIndex || 0}
                />
              ),
            },
            {
              name: t("Store"),
              content: <ThirdPartyB2b activeTab="b2b" />,
            },
          ]
          : []),
        {
          name: t("Insurance Claims"),
          content: (
            <ClaimInsurancePage
              activeTab="ins"
              childIndex={location?.state?.childIndex}
            />
          ),
        },
        { name: t("His Reception"), content: null },
        { name: t("Pharmacy"), content: null },
      ];
    } else if (user.role_id === 5 && user?.business_id == 40) {
      return [
        {
          name: t("Store"),
          content: <ThirdPartyB2b activeTab="b2b" />,
        },
      ];
    } else if (user.role_id === 6 && user?.business_id == 40) {
      return [
        {
          name: t("Gallery"),
          content: (
            <ThirdPartyTable
              activeTab="b2c"
              childIndex={location?.state?.childIndex || 0}
            />
          ),
        },
      ];
    }

    return [];
  };

  const tabs = getTabsForUser();

  return (
    <div>
      <CustomTabs
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
      />

      {/* ===== OLD TAB IMPLEMENTATION (COMMENTED OUT) =====
      <ul className="grid grid-flow-col mb-2 text-center text-gray-500 bg-gray-100 border rounded p-1 shadow-inner">
        {tabsList.map((tab) => (
          <li key={tab.value}>
            <a
              className={`flex justify-center py-2 cursor-pointer hover:text-primary ${activeTab === tab.value
                  ? "bg-primary rounded shadow text-white hover:text-white"
                  : ""
                }`}
              onClick={() => handleTabClick(tab)}
            >
              {tab.label}
            </a>
          </li>
        ))}
      </ul>
      {activeTab === "b2c" ? (
        <ThirdPartyTable
          activeTab={activeTab}
          childIndex={location?.state?.childIndex || 0}
        />
      ) : activeTab === "b2b" ? (
        <ThirdPartyB2b activeTab={activeTab} />
      ) : activeTab === "ins" ? (
        <ClaimInsurancePage
          activeTab={activeTab}
          childIndex={location?.state?.childIndex}
        />
      ) : null}
      ===== END OLD TAB IMPLEMENTATION ===== */}
    </div>
  );
}

export default ThirdParty;
